import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import cn from '@/utils/merge-class-names';

interface Props {
  label?: string;
  className?: string;
}

export default function EmptyLayout({ label, children, className }: PropsWithChildren<Props>) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex size-full flex-center', className)}>
      <p className='text-body1 text-base-300'>{children ?? (label ? t(label) : null)}</p>
    </div>
  );
}
